import React from 'react';

// Types
import { ValidationMessageProps } from '../../types/display/validation';

// Components
import { Typography } from '../Typography/Typography';

export const ValidationMessage = ({ children }: ValidationMessageProps) => (
  <Typography component="small" className="block has-error">
    {children}
  </Typography>
);
